module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar",
    staticStyle: {
      "position": "fixed",
      "width": "15%",
      "height": "99vh",
      "bottom": "0px",
      "left": "0px",
      "background": "#ffffff",
      "border-top-left-radius": "18px",
      "z-index": "10000"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-sidebar-body"
  }, [(_vm.site_user_type == 2) ? _c('div', {
    staticClass: "card-sidebar-group",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), ((Object.keys(_vm.sellpoints).length > 1)) ? _c('li', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('showBusinesses')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "margin-left": "1em",
      "margin-top": "0.8em"
    },
    attrs: {
      "id": "showBusinesses"
    }
  }, _vm._l((_vm.sellpoints), function(sp, i) {
    return _c('li', {
      key: i
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.sellpoint = sp;
          _vm.setSellpoint();
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fas fa-arrow-right"
    }), _vm._v(_vm._s(sp.business_name))])])])
  })), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "0px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-sidebar-group",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', [(_vm.site_user_type == 2) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.site_user_type == 2) ? _c('li', [_vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.site_user_type == 1) ? _c('li', [_vm._m(8), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "0.3em",
      "margin-top": "0.8em"
    }
  }, [((Object.keys(_vm.customers_details).length > 0)) ? _c('div', {
    staticStyle: {
      "margin-left": "2em",
      "margin-top": "0.8em"
    }
  }, [_vm._l((_vm.customers_details), function(fave, fdex) {
    return _c('li', {
      key: fdex,
      staticClass: "txt-00"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/' + fave.customer_business_username
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px",
        "width": "3em"
      }
    }, [_vm._v(_vm._s(fave.customer_business_name) + " asss hbhhaav bhh vvvf sss")]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-angle-right",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), _vm._v(" "), _vm._m(9)], 2) : _c('div', {
    staticStyle: {
      "margin-left": "183em"
    }
  }, [_c('li', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v("None added yet")]), _vm._v(" "), _vm._m(10)])])]) : _vm._e()])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "card-sidebar-footer",
    staticStyle: {
      "position": "fixed",
      "bottom": "5px",
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "line-height": "0.5",
      "font-size": "12px",
      "background-color": "#ffe600"
    },
    attrs: {
      "href": "/settings/profile"
    }
  }, [_vm._v("View Profile")])])]), _vm._v(" "), _vm._m(13)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar-head",
    staticStyle: {
      "margin-top": "-1.8em",
      "margin-bottom": "5px",
      "border-bottom": "#eee solid 1px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "text-transform": "capitalize",
      "font-size": "18px",
      "font-weight": "bolder",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/brand001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("easy-peasy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("store"), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("______________")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _c('span', [_vm._v("Lucas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _c('span', [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/search"
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _c('span', [_vm._v("Order From")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _c('span', [_vm._v("Orders")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items"
    }
  }, [_c('i', {
    staticClass: "fas fa-table"
  }), _c('span', [_vm._v("Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0.32em",
      "margin-top": "0.8em",
      "font-size": "smaller"
    }
  }, [_c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v("Store Items")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/regular"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v("Regular Items")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/available"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v("Available Items")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/manage/items/categories"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v("Categories")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fas fa-store"
  }), _c('span', [_vm._v("Favorites")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/lists/places"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("All ...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/search"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "display": "none"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-sidebar-group",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("more"), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("______________")])]), _vm._v(" "), _c('div', [_c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/settings"
    }
  }, [_c('i', {
    staticClass: "fas fa-gear"
  }), _c('span', [_vm._v("Settings")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _c('span', [_vm._v("Notifications")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/support"
    }
  }, [_c('i', {
    staticClass: "fas fa-support"
  }), _c('span', [_vm._v("Support")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-avatar-circle-xx",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px",
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("© 2023, Place Order")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f516bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DesktopViews/Sidebar.vue
// module id = 602
// module chunks = 0